import { render, staticRenderFns } from "./AuthoritiesList.vue?vue&type=template&id=1313e3f8&scoped=true"
import script from "./AuthoritiesList.vue?vue&type=script&lang=js"
export * from "./AuthoritiesList.vue?vue&type=script&lang=js"
import style0 from "./AuthoritiesList.vue?vue&type=style&index=0&id=1313e3f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1313e3f8",
  null
  
)

export default component.exports